export default "__VITE_ASSET__2c424db8__"